import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/flights/passengers.ts
import { Exception } from "@wbk/logger";
var createPassenger = (passenger) => __async(void 0, null, function* () {
  try {
    const res = yield fetchClient({
      url: "/flights/passengers",
      version: "v1",
      options: {
        method: "POST",
        body: JSON.stringify(passenger)
      }
    });
    return res.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "createPassengerException"
    });
  }
});
var updatePassenger = (passenger) => __async(void 0, null, function* () {
  try {
    const res = yield fetchClient({
      url: `/flights/passengers/${passenger.id}`,
      version: "v1",
      options: {
        method: "PUT",
        body: JSON.stringify(passenger)
      }
    });
    return res.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "updatePassengerException"
    });
  }
});
var getAllPassengers = (passengerType) => __async(void 0, null, function* () {
  try {
    const params = new URLSearchParams();
    if (passengerType) {
      params.append("passenger_type", passengerType);
    }
    const response = yield fetchClient({
      url: `/flights/passengers?${params.toString()}`,
      version: "v1"
    });
    return response.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getAllPassengersException"
    });
  }
});
var getPassenger = (id) => __async(void 0, null, function* () {
  try {
    const response = yield fetchClient({
      url: `/flights/passengers/${id}`,
      version: "v1"
    });
    return response.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getPassengerException"
    });
  }
});
var deletePassenger = (id) => __async(void 0, null, function* () {
  try {
    yield fetchClient({
      url: `/flights/passengers/${id}`,
      version: "v1",
      options: {
        method: "DELETE"
      }
    });
  } catch (error) {
    throw new Exception({
      error,
      name: "deletePassengerException"
    });
  }
});

export {
  createPassenger,
  updatePassenger,
  getAllPassengers,
  getPassenger,
  deletePassenger
};
//# sourceMappingURL=chunk-UWUX3UL5.mjs.map